export const CONTACT_IMAGE_BASE_URL = `${process.env.VUE_APP_API_WWW_ROOT}/ContactImages`;
export const LOGO_IMAGE_BASE_URL = `${process.env.VUE_APP_API_WWW_ROOT}/LogoImages`;
export const REPORT_BASE_URL = `${process.env.VUE_APP_API_WWW_ROOT}/Reports`;
